(function () {
  const CARD_LONG_MM = 85.6;
  const CARD_SHORT_MM = 53.98;
  const CAL_SLIDER_MIN = 50;
  const CAL_SLIDER_MAX = 250;
  const MOBILE_MQ = '(max-width: 767px)';
  const CSS_PX_PER_MM = 96 / 25.4;
  const MOBILE_SCREEN_WIDTH_MM = 71;

  const insideDiameterData = [
    '14.05 & 44.14', '14.24 & 44.74', '14.45 & 45.40', '14.65 & 46.02', '14.88 & 46.80',
    '15.09 & 47.40', '15.29 & 48.00', '15.49 & 48.70', '15.70 & 49.30', '15.90 & 50.00',
    '16.10 & 50.60', '16.31 & 51.20', '16.51 & 51.90', '16.71 & 52.50', '16.92 & 53.10',
    '17.12 & 53.80', '17.32 & 54.40', '17.53 & 55.10', '17.73 & 55.70', '17.93 & 56.30',
    '18.14 & 57.00', '18.34 & 57.60', '18.54 & 58.30', '18.75 & 58.90', '18.95 & 59.50',
    '19.15 & 60.20', '19.35 & 60.80', '19.56 & 61.40', '19.76 & 62.10', '19.96 & 62.70',
    '20.17 & 63.40', '20.37 & 64.00', '20.57 & 64.60', '20.78 & 65.30', '20.98 & 65.90',
    '21.18 & 66.60', '21.39 & 67.20', '21.59 & 67.80', '21.79 & 68.50', '22.00 & 69.10',
    '22.20 & 69.70', '22.40 & 70.40', '22.61 & 71.00', '22.81 & 71.70', '23.01 & 72.30',
    '23.22 & 72.90', '23.42 & 73.60', '23.62 & 74.20', '24.23 & 76.10',
  ];

  const usSizes = [
    '3', '3.25', '3.5', '3.75', '4', '4.25', '4.5', '4.75', '5', '5.25', '5.5', '5.75', '6',
    '6.25', '6.5', '6.75', '7', '7.25', '7.5', '7.75', '8', '8.1', '8.25', '8.5', '8.75', '9',
    '9.25', '9.5', '9.75', '10', '10.25', '10.5', '10.75', '11', '11.25', '11.5', '11.75', '12',
    '12.25', '12.5', '12.75', '13', '13.25', '13.5', '14', '14.25', '14.5', '14.75', '15',
  ];

  function parseMeasurement(raw) {
    const parts = String(raw).split('&').map((s) => parseFloat(s.trim()));
    return { diameter: parts[0], circumference: parts[1] };
  }

  function formatRingSize(size) {
    const str = String(size).trim();
    if (/^[A-Za-z]/.test(str)) return str;
    const num = parseFloat(str);
    if (Number.isNaN(num)) return str;
    return num.toFixed(2);
  }

  function showEl(el) {
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('hidden');
  }

  function hideEl(el) {
    if (!el) return;
    el.hidden = true;
    el.setAttribute('hidden', '');
  }

  class RingSizeVisual {
    constructor(root) {
      this.root = root;
      this.shopUrl = root.dataset.shopUrl || '/collections/engagement-rings';
      /** @type {{ pixelsPerMm: number, calScale: number, heightPx: number, widthPx: number, portrait: boolean } | null} */
      this.calibration = null;
      this.calScale = 100;
      this.ringIndex = 19;
      this.currentUsSize = null;

      this.cacheDom();
      if (!this.els.card) return;

      this.bindEvents();
      this.updateCardScale();
      this.els.ringSlider.value = String(this.ringIndex);
    }

    cacheDom() {
      const r = this.root;
      this.els = {
        stepIndicators: r.querySelectorAll('[data-rv-step]'),
        calibrateScreen: r.querySelector('[data-rv-calibrate]'),
        measureScreen: r.querySelector('[data-rv-measure]'),
        calLockedBadge: r.querySelector('[data-rv-cal-locked]'),
        calibrateZone: r.querySelector('[data-rv-calibrate-zone]'),
        cardScaler: r.querySelector('[data-rv-card-scaler]'),
        card: r.querySelector('[data-rv-card]'),
        measureStage: r.querySelector('[data-rv-measure-stage]'),
        ringSvg: r.querySelector('[data-rv-ring-svg]'),
        ringCircle: r.querySelector('[data-rv-ring-circle]'),
        calSlider: r.querySelector('[data-rv-cal-slider]'),
        calMinus: r.querySelector('[data-rv-cal-minus]'),
        calPlus: r.querySelector('[data-rv-cal-plus]'),
        scaleValue: r.querySelector('[data-rv-scale-value]'),
        calLockedText: r.querySelector('[data-rv-cal-locked-text]'),
        calError: r.querySelector('[data-rv-cal-error]'),
        ringSlider: r.querySelector('[data-rv-ring-slider]'),
        ringMinus: r.querySelector('[data-rv-ring-minus]'),
        ringPlus: r.querySelector('[data-rv-ring-plus]'),
        sizeLabel: r.querySelector('[data-rv-size-label]'),
        resultBox: r.querySelector('[data-rv-result]'),
        resultUs: r.querySelector('[data-rv-us]'),
        copyBtn: r.querySelector('[data-rv-copy]'),
        shopBtn: r.querySelector('[data-rv-shop]'),
        nextBtn: r.querySelector('[data-rv-next]'),
        backBtn: r.querySelector('[data-rv-back]'),
      };

      if (this.els.shopBtn) {
        this.els.shopBtn.href = this.shopUrl;
      }
    }

    bindEvents() {
      const { calSlider, ringSlider } = this.els;

      calSlider?.addEventListener('input', () => {
        this.calScale = parseInt(calSlider.value, 10);
        this.hideCalibrateError();
        this.updateCardScale();
      });

      this.els.calMinus?.addEventListener('click', () => this.nudgeCalSlider(-1));
      this.els.calPlus?.addEventListener('click', () => this.nudgeCalSlider(1));
      this.els.ringMinus?.addEventListener('click', () => this.nudgeRingSlider(-1));
      this.els.ringPlus?.addEventListener('click', () => this.nudgeRingSlider(1));

      ringSlider?.addEventListener('input', () => {
        this.ringIndex = parseInt(ringSlider.value, 10);
        this.updateRingVisual();
      });

      this.els.nextBtn?.addEventListener('click', () => this.goToMeasure());
      this.els.backBtn?.addEventListener('click', () => this.goToCalibrate());
      this.els.copyBtn?.addEventListener('click', () => this.copySize());

      window.addEventListener('resize', () => {
        if (!this.els.calibrateScreen?.hidden) {
          this.updateCardScale();
        }
      });
    }

    isPortraitLayout() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    /**
     * Starting card size (slider fine-tunes). Lock uses actual on-screen size only —
     * same physical ring → same US size on any device after a true card match.
     */
    getEstimatedPxPerMm() {
      if (this.isPortraitLayout()) {
        return window.innerWidth / MOBILE_SCREEN_WIDTH_MM;
      }
      return CSS_PX_PER_MM;
    }

    getStagePadding() {
      const stage = this.els.calibrateZone?.closest('.rv-stage--card');
      if (!stage) return { x: 0, y: 0, width: window.innerWidth, height: 480 };
      const style = getComputedStyle(stage);
      const x = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      const y = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      return {
        x,
        y,
        width: Math.max(120, stage.clientWidth - x),
        height: Math.max(160, Math.min(window.innerHeight * 0.58, 520) - y),
      };
    }

    /**
     * Shrink base mm estimate so even at CAL_SLIDER_MAX the card fits inside the stage.
     */
    clampPxPerMmToStage(pxPerMm) {
      const stage = this.getStagePadding();
      const portrait = this.isPortraitLayout();
      const baseWmm = portrait ? CARD_SHORT_MM : CARD_LONG_MM;
      const baseHmm = portrait ? CARD_LONG_MM : CARD_SHORT_MM;
      const maxScale = CAL_SLIDER_MAX / 100;
      const shadowPad = 16;

      const maxPxW = (stage.width - shadowPad) / (baseWmm * maxScale);
      const maxPxH = (stage.height - shadowPad) / (baseHmm * maxScale);

      return Math.min(pxPerMm, maxPxW, maxPxH);
    }

    applyCardBaseDimensions() {
      const card = this.els.card;
      if (!card) return;

      let pxPerMm = this.clampPxPerMmToStage(this.getEstimatedPxPerMm());
      const portrait = this.isPortraitLayout();

      const baseW = portrait ? CARD_SHORT_MM * pxPerMm : CARD_LONG_MM * pxPerMm;
      const baseH = portrait ? CARD_LONG_MM * pxPerMm : CARD_SHORT_MM * pxPerMm;

      card.dataset.baseWidth = String(baseW);
      card.dataset.baseHeight = String(baseH);
      this.applyCalScaleToCard();
    }

    applyCalScaleToCard() {
      const card = this.els.card;
      if (!card) return;

      const baseW = parseFloat(card.dataset.baseWidth);
      const baseH = parseFloat(card.dataset.baseHeight);
      if (!baseW || !baseH) return;

      const scale = this.calScale / 100;
      const w = baseW * scale;
      const h = baseH * scale;
      card.style.width = `${w}px`;
      card.style.height = `${h}px`;
      card.style.setProperty('--rv-card-min', `${Math.min(w, h)}px`);

      if (this.els.cardScaler) {
        this.els.cardScaler.style.transform = 'none';
      }
    }

    nudgeCalSlider(delta) {
      const slider = this.els.calSlider;
      if (!slider) return;
      const next = Math.min(CAL_SLIDER_MAX, Math.max(CAL_SLIDER_MIN, parseInt(slider.value, 10) + delta));
      slider.value = String(next);
      this.calScale = next;
      this.hideCalibrateError();
      this.updateCardScale();
    }

    nudgeRingSlider(delta) {
      const slider = this.els.ringSlider;
      if (!slider) return;
      const next = Math.min(48, Math.max(0, parseInt(slider.value, 10) + delta));
      slider.value = String(next);
      this.ringIndex = next;
      this.updateRingVisual();
    }

    updateCardScale() {
      this.applyCardBaseDimensions();
      this.updateScaleDisplay();
      requestAnimationFrame(() => this.syncCalibrateZone());
    }

    updateScaleDisplay() {
      if (this.els.scaleValue) {
        this.els.scaleValue.textContent = `${this.calScale}%`;
      }
    }

    syncCalibrateZone() {
      if (!this.els.card || !this.els.calibrateZone) return;

      const w = Math.ceil(this.els.card.offsetWidth);
      const h = Math.ceil(this.els.card.offsetHeight);
      if (w < 1 || h < 1) return;

      this.els.calibrateZone.style.width = `${w}px`;
      this.els.calibrateZone.style.height = `${h}px`;
    }

    /**
     * Device-agnostic: locked from what user actually matched on screen.
     * pixelsPerMm × ring diameter (mm) = same US index on every device.
     */
    readCalibrationFromCard() {
      const rect = this.els.card.getBoundingClientRect();
      const portrait = this.isPortraitLayout();

      const longEdgePx = portrait ? rect.height : rect.width;
      const shortEdgePx = portrait ? rect.width : rect.height;

      const ppmLong = longEdgePx / CARD_LONG_MM;
      const ppmShort = shortEdgePx / CARD_SHORT_MM;
      const pixelsPerMm = (ppmLong + ppmShort) / 2;
      const driftPct = (Math.abs(ppmLong - ppmShort) / pixelsPerMm) * 100;

      return {
        pixelsPerMm,
        ppmLong,
        ppmShort,
        driftPct,
        calScale: this.calScale,
        heightPx: rect.height,
        widthPx: rect.width,
        portrait,
        valid: longEdgePx >= 40 && shortEdgePx >= 24 && driftPct < 5,
      };
    }

    showCalibrateError() {
      showEl(this.els.calError);
    }

    hideCalibrateError() {
      hideEl(this.els.calError);
    }

    lockCalibration() {
      const reading = this.readCalibrationFromCard();
      if (!reading.valid) return false;

      this.calibration = {
        pixelsPerMm: reading.pixelsPerMm,
        calScale: reading.calScale,
        heightPx: reading.heightPx,
        widthPx: reading.widthPx,
        portrait: reading.portrait,
      };

      return true;
    }

    clearCalibration() {
      this.calibration = null;
      hideEl(this.els.calLockedBadge);
    }

    getPixelsPerMm() {
      return this.calibration?.pixelsPerMm ?? null;
    }

    goToMeasure() {
      if (!this.lockCalibration()) {
        this.showCalibrateError();
        return;
      }

      this.hideCalibrateError();

      hideEl(this.els.calibrateScreen);
      showEl(this.els.measureScreen);
      showEl(this.els.calLockedBadge);

      if (this.els.calLockedText && this.calibration) {
        this.els.calLockedText.textContent = 'Screen calibrated';
      }

      this.els.stepIndicators?.forEach((step) => {
        const n = step.dataset.rvStep;
        step.classList.toggle('is-active', n === '2');
        step.classList.toggle('is-done', n === '1');
      });

      this.updateRingVisual();
      this.els.measureStage?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    goToCalibrate() {
      this.clearCalibration();
      this.hideCalibrateError();

      showEl(this.els.calibrateScreen);
      hideEl(this.els.measureScreen);
      this.updateCardScale();

      this.els.stepIndicators?.forEach((step) => {
        step.classList.toggle('is-active', step.dataset.rvStep === '1');
        step.classList.remove('is-done');
      });
    }

    updateRingVisual() {
      const pixelsPerMm = this.getPixelsPerMm();
      if (!pixelsPerMm || !this.els.ringCircle || !this.els.ringSvg) return;

      const raw = insideDiameterData[this.ringIndex];
      if (!raw) return;

      const m = parseMeasurement(raw);
      const diameterPx = m.diameter * pixelsPerMm;
      const pad = 16;
      const size = Math.ceil(diameterPx) + pad * 2;
      const center = size / 2;
      const radius = diameterPx / 2;

      this.els.ringSvg.setAttribute('width', String(size));
      this.els.ringSvg.setAttribute('height', String(size));
      this.els.ringSvg.setAttribute('viewBox', `0 0 ${size} ${size}`);

      const circle = this.els.ringCircle;
      circle.setAttribute('cx', String(center));
      circle.setAttribute('cy', String(center));
      circle.setAttribute('r', String(radius));
      circle.setAttribute('stroke-width', String(Math.max(3.5, diameterPx * 0.045)));

      const usSize = formatRingSize(usSizes[this.ringIndex] || usSizes[0]);
      this.currentUsSize = usSize;

      if (this.els.sizeLabel) {
        this.els.sizeLabel.textContent = `${usSize} US`;
      }
      if (this.els.resultUs) {
        this.els.resultUs.innerHTML = `${usSize} <span>US</span>`;
      }
      showEl(this.els.resultBox);

      const sizeParam = encodeURIComponent(usSize);
      if (this.els.shopBtn) {
        this.els.shopBtn.href = `${this.shopUrl}${this.shopUrl.includes('?') ? '&' : '?'}ring_size=${sizeParam}`;
      }
    }

    async copySize() {
      if (!this.currentUsSize) return;
      const text = `${this.currentUsSize} US`;
      try {
        await navigator.clipboard.writeText(text);
        const btn = this.els.copyBtn;
        const prev = btn.textContent;
        btn.textContent = 'Copied!';
        btn.classList.add('is-copied');
        setTimeout(() => {
          btn.textContent = prev;
          btn.classList.remove('is-copied');
        }, 2000);
      } catch {
        /* silent */
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-ring-visual]').forEach((root) => {
      new RingSizeVisual(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
